import React from 'react';
import { SkinMolesComponent } from '#components/skin';

const SkinMolesPageWrapper = () => {
  return (
    <main>
      <SkinMolesComponent />
    </main>
  );
};

export default SkinMolesPageWrapper;
